<template>
  <div v-loading="loading">
    <div
      :class="{'flex-row-center': !hideViewWayTabs}"
    >
      <yxtf-radio-group
        v-model="skillCatalogId"
        class="gwnl-web-radio-group zIndex5"
      >
        <yxtf-radio-button
          v-for="catalogs in jqSkillCatalogList"
          :key="catalogs.id"
          :label="catalogs.id"
        >
          <yxtf-tooltip
            placement="top"
            trigger="hover"
            :content="catalogs.name"
            open-filter
            :max-width="250"
          >
            <div
              class="ellipsis"
              style="max-width: 180px;"
            >
              {{ catalogs.name }}
            </div>
          </yxtf-tooltip>
        </yxtf-radio-button>
      </yxtf-radio-group>
      <slot />
    </div>
    <div
      v-if="detail && detail.jqSkillClassifications && detail.jqSkillClassifications.length>0"
      class="gwnl-web-position-detail-skills-detail relative"
      :class="{'mt-32': !hideViewWayTabs}"
    >
      <!-- showSkillLevel 测评完成前不显示能力级别(0-关闭,1-开启) -->
      <skills-left
        v-if="!hideRadar"
        ref="skillLeftRef"
        class="gwnl-web-position-detail-skills-left"
        :class="leftFlex"
        :hide-view-way-tabs="hideViewWayTabs"
        :close-animate="closeAnimate"
        :scene="scene"
        :detail="detail"
        :fields="fields"
        :hideSkillLevelBeforeEval="hideSkillLevelBeforeEval"
        :skillWithLevel="skillWithLevel"
        @viewerSwitched="handleSwitch"
      />

      <div
        v-if="!hideRight && !noRight"
        class="mt64 skills_divider"
      />
      <template>
        <div
          v-show="onlyStandardModel"
          :class="{'flex-1': !hideRight && !noRight}"
        >
          <skills-right
            v-show="!hideRight"
            ref="skillRight"
            :evaluation-list="evaluationList"
            :no-right="noRight"
            :scene="scene"
            :detail="detail"
            :fields="fields"
            :skillWithLevel="skillWithLevel"
            :class="{'gwnl-web-position-detail-skills-right over-auto': !noRight}"
            @getRadarDetail="getRadarDetail"
          />
        </div>
      </template>
    </div>

    <yxtf-empty v-else />
  </div>
</template>

<script>
import skillsLeft from './skills-left';
import skillsRight from './skills-right';

export default {
  components: { skillsLeft, skillsRight },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    closeAnimate: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      default: () => []
    },
    scene: {
      type: Number,
      default: 1 // 1 岗位地图 2 测训一体
    },
    evaluationDetail: {
      type: Object,
      default: () => {}
    },
    onlyStandardModel: {
      type: Boolean,
      default: true
    },
    evaluationList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      skillCatalogId: '',
      hideRight: false,
      hideRadar: false,
      showSkillLevel: 0, // 1-开启了完成测评前不显示模型 0-未开启
      enableSkillLevel: 1, // 1-有等级 0-无等级
      detail: {}
    };
  },
  computed: {
    leftFlex() {
      return (!this.hideRight && !this.noRight) ? 'pwidth50' : 'flex-1';
    },
    skillWithLevel() { // 是否开启能力等级
      return this.enableSkillLevel === 1;
    },
    hideSkillLevelBeforeEval() { // 是否开启了完成测评前不显示模型
      return this.showSkillLevel === 1;
    },
    hideViewWayTabs() {
      // haveLevelButNotShowBeforeEval 有等级, 但开启了完成测评前不显示模型
      const haveLevelButNotShowBeforeEval = this.hideSkillLevelBeforeEval && this.skillWithLevel;
      const noLevel = !this.skillWithLevel;
      return (haveLevelButNotShowBeforeEval || noLevel) && this.onlyStandard;
    },
    noRight() {
      if (this.scene === 2) {
        return this.onlyStandard;
      } else {
        return this.detail.advantage && this.detail.improve && this.detail.advantage.length === 0 && this.detail.improve.length === 0;
      }
    },
    onlyStandard() {
      return this.enabledFields.findIndex(item => item !== 'combStandardLevel' && item !== 'excellentEavl') === -1;
    },
    enabledFields() {
      return this.fields.filter(item => item.selected).map(item => item.name);
    },
    jqSkillCatalogList() {
      return this.evaluationDetail.skillCatalog || [];
    }
  },
  watch: {
    evaluationDetail: {
      handler(val) {
        const list = val.skillCatalog ? val.skillCatalog : [];
        this.skillCatalogId = list.length && list[0].id;
        this.cataLogChanged(this.skillCatalogId);
        this.showSkillLevel = val.showSkillLevel;
        this.enableSkillLevel = val.enableSkillLevel;
      },
      deep: true,
      immediate: true
    },
    skillCatalogId: {
      handler(val) {
        this.cataLogChanged(val);
      },
      immediate: true
    }
  },
  methods: {
    cataLogChanged(val) {
      const currentCatalogDetail = this.evaluationDetail.skillCatalog && this.evaluationDetail.skillCatalog.find(item => {
        return item.id === val;
      }) || {};
      this.detail = currentCatalogDetail;
    },
    handleSwitch(showRadar) {
      this.hideRight = !showRadar;
      if (showRadar) { // 切换回雷达图时重新渲染整个区域，防止雷达图渲染成100%的空间
        this.hideRadar = true;
        this.$nextTick(() => {
          this.hideRadar = false;
        });
      }
    },
    getRadarDetail(evalId) {
      this.$emit('getRadarDetail', evalId);
    },
    resetSkillRight() {
      this.$refs.skillRight.reset();
    }
  }
};
</script>

<style lang="scss" scoped>
  .flex-1 {
    flex: 1;
  }
</style>
